import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { Moment } from 'moment';
import { DateRange } from 'moment-range';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;


type DateRangeSelectorPickerProps = {
  quickRanges: Record<string, [Moment, Moment]>;
  onChange: (dates: string[]) => void;
  maxDaysSelected: number;
  dateFormat: string;
  dataAvailableDates: DateRange[];
};

const DateRangeSelectorPicker = (props: DateRangeSelectorPickerProps) => {
  // This stuff is how antd recommends doing. I wouldn't mess with it unless you really need to.
  const [dates, setDates] = useState<[Moment, Moment]>();
  const [hackValue, setHackValue] = useState<[Moment, Moment]>();
  const [value, setValue] = useState<[Moment, Moment]>();

  const disabledDate = (current: Moment) => {
    // Check that we have data available
    let isDataAvailable = false;
    // TODO Un-hard-code this
    for (const range of props.dataAvailableDates) {
      if (current.within(range)) isDataAvailable = true;
    }
    if (!isDataAvailable) return true;

    // if (current && current > moment().endOf('day')) return true;
    if (!dates || !dates.length) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') > props.maxDaysSelected;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > props.maxDaysSelected;
    return tooEarly || tooLate;
  };

  // This function doesn't really make much sense to me either, but it works. It's pulled from here:
  // https://ant.design/components/date-picker/#components-date-picker-demo-select-in-range
  const onOpenChange = (open: unknown) => {
    if (open) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setHackValue([]);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setDates([]);
    } else {
      setHackValue(undefined);
    }
  };

  return (

    <RangePicker
      // className="input-item"
      // style={{marginLeft: '8px', marginRight: '8px'}}
      value={hackValue || value || dates}
      disabledDate={disabledDate}
      ranges={props.quickRanges}
      // onChange={event => dateChanged(event)}
      onOpenChange={onOpenChange}
      onCalendarChange={val => {
        setDates(val as [Moment, Moment]);
        if (val && val[0] && val[1]) {
          if (Math.abs(val[0].diff(val[1], 'days')) > props.maxDaysSelected) {
            toast.warning(`Too many days selected, ${props.maxDaysSelected} max.`);
          } else props.onChange((val as [Moment, Moment]).map(d => d.format(props.dateFormat)));
        }
      }}
      onChange={val => {
        setValue(val as [Moment, Moment]);
      }}
    />
  );
};
export default DateRangeSelectorPicker;
